import { z } from 'zod';
/**
 * Theme-System (SPEC 8.4).
 *
 * Ein Theme ist eine Menge von CSS-Custom-Properties, die zur Laufzeit auf
 * `:root` gesetzt werden — je ein Satz fuer hell und dunkel.
 *
 * ZWEI ABWEICHUNGEN VON DER SPEC, beide bewusst:
 *
 * 1. Die mitgelieferten Themes liegen in `packages/shared`, nicht in
 *    `apps/web/src/themes`. Die API muss sie ausliefern und kann nicht aus
 *    `apps/web` importieren; zwei Kopien waeren zwei Stellen, die
 *    auseinanderlaufen. Dateien, die zur Laufzeit abgelegt werden, sind
 *    weiterhin JSON — dafuer gibt es das Verzeichnis in `THEMES_DIR`.
 *
 * 2. Ein Theme ueberschreibt nur, was es aendern will. Die Vollstaendigkeit
 *    liefert `tokens.css`. Muesste jedes Theme alle 45 Farbwerte mitbringen,
 *    waere jedes neue Theme ein Kontrastgutachten — so ist es eine Handvoll
 *    Werte, und die Pruefung rechnet trotzdem den zusammengesetzten Stand
 *    nach (contrast.test.ts).
 *
 * `radius` und `font` aus der SPEC sind keine Sonderfaelle, sondern schlicht
 * die Token `--radius` und `--font-sans`. Ein Mechanismus statt drei.
 */
/** Nur Token-Namen, keine beliebigen CSS-Eigenschaften. */
const tokenNameSchema = z.string().regex(/^--[a-z0-9-]{2,40}$/, 'Kein gueltiger Token-Name');
/**
 * Werte werden eng gefasst. Gesetzt wird zwar ueber `style.setProperty`, wo
 * nichts ausbrechen kann — aber ein Theme ist eine Datei, die jemand ablegt,
 * und was von aussen kommt, wird geprueft, nicht gehofft.
 */
const tokenValueSchema = z
    .string()
    .min(1)
    .max(120)
    .regex(/^[^;{}<>]+$/u, 'Unerlaubtes Zeichen im Wert')
    .refine((value) => !/url\s*\(|expression\s*\(|@import/iu.test(value), 'Unerlaubte Funktion');
const tokenMapSchema = z.record(tokenNameSchema, tokenValueSchema);
export const themeSchema = z.object({
    id: z
        .string()
        .regex(/^[a-z0-9][a-z0-9-]{1,39}$/, 'Kennung nur aus Kleinbuchstaben, Ziffern und Bindestrich'),
    name: z.string().min(1).max(40),
    light: tokenMapSchema.default({}),
    dark: tokenMapSchema.default({}),
});
export const DEFAULT_THEME_ID = 'default';
//# sourceMappingURL=theme.js.map